import { CoreLogger } from '../logger/core-logger';

export const getOrigin = (baseURL: string): string => {
  if (baseURL.startsWith('http')) {
    return baseURL;
  }
  if (!baseURL.startsWith('/')) {
    CoreLogger.loggerManager.warn(
      'CSS path is relative, using absolute instead. Path should be defined either as a full URL or an absolute path.',
    );
  }
  return `${window.location.origin}/${baseURL.replace(/^\//, '')}`;
};

export class ThemeStyleSheet {
  public static baseURLPolyfill(cssText: string, baseURL: string) {
    // source https://github.com/systemjs/systemjs/blob/9647576d43294e938ddae8fe231beb62255f4e46/src/extras/module-types.js#L42
    // replaces url with baseURL version
    return cssText.replace(
      /url\(\s*(?:(["'])((?:\\.|[^\n\\"'])+)\1|((?:\\.|[^\s,"'()\\])+))\s*\)/g,
      function (match, quotes, relUrl1, relUrl2) {
        const u =
          (relUrl1 as unknown as string) || (relUrl2 as unknown as string);
        const resolveUrl = new URL(u, getOrigin(baseURL));
        return ['url(', quotes, resolveUrl.href, quotes, ')'].join('');
      },
    );
  }
  private static processFontsDefinitions(
    styleSheet: CSSStyleSheet,
    cssUrl: string = '',
  ) {
    const fontsRules: CSSRule[] = Array.from(styleSheet.cssRules).filter(
      (rule) => rule.constructor.name === 'CSSFontFaceRule', //type is deprecated
    );
    if (fontsRules.length) {
      const fontStylesheet = new CSSStyleSheet();
      fontsRules.forEach((rule) =>
        fontStylesheet.insertRule(rule.cssText, fontStylesheet.cssRules.length),
      );
      document.adoptedStyleSheets?.push(fontStylesheet);
      CoreLogger.loggerManager.info('Adding fonts not from global css', cssUrl);
    }
  }

  public static async createAdoptedStylesheet(
    cssText: string,
    url: string = window.location.origin,
    global = false,
  ): Promise<CSSStyleSheet> {
    const constructedStylesheet = new CSSStyleSheet({ baseURL: url });
    cssText = this.baseURLPolyfill(cssText, url);
    await constructedStylesheet.replace(cssText);
    if (!global) {
      const resultStylesheet = new CSSStyleSheet({ baseURL: url });
      this.processFontsDefinitions(constructedStylesheet, url);
      Array.from(constructedStylesheet.cssRules || []).forEach((rule) => {
        // we might have multiple :root instances throughout the stylesheet
        if ((rule as CSSStyleRule).selectorText === ':root') {
          const cssHostText = rule.cssText.replace(':root', ':host');
          resultStylesheet.insertRule(
            cssHostText,
            resultStylesheet.cssRules.length,
          );
        } else {
          resultStylesheet.insertRule(
            rule.cssText,
            resultStylesheet.cssRules.length,
          );
        }
      });

      return resultStylesheet;
    }
    return constructedStylesheet;
  }
}
